import { Stack } from '@chakra-ui/react'
import { InputFormControl, TextareaFormControl } from 'BrokerTsLib/src/components'
import type { EditOrganizationUnit } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import type { Ref } from 'react'
import { forwardRef } from 'react'

import { SwitchInput } from '@/components/SwitchInput'
import type { FormSectionProps } from '@/containers/forms/FormSection'
import { FormSection } from '@/containers/forms/FormSection'

export const OrganizationVehicleInsuranceFormSection = forwardRef(
  function OrganizationVehicleInsuranceFormSection(props: FormSectionProps, ref: Ref<HTMLDivElement>) {
    const { control, register } = useFormContext<EditOrganizationUnit>()

    return <FormSection ref={ref} sectionTitle='Nastavení pojištění vozidel' {...props}><Stack gap={6}>
      <TextareaFormControl label="Odkazy na dokumenty"
        placeholder="Odkazy na dokumenty ke stažení"
        control={control} name="properties.preContractDocumentLinks" />
      <InputFormControl label="Odkaz na IPID"
        placeholder="Odkaz na IPIDy"
        control={control} name="properties.ipidLink" />

      <SwitchInput {...register('properties.allianzNoYearkm')}>Autobazar</SwitchInput>

      <SwitchInput {...register('properties.showPreferredLiquidation')}>Zobrazit Preferovaný způsob likvidace škod</SwitchInput>
    </Stack>
    </FormSection>
  }
)